/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CheckAzureVMNameExists200Response {
  /**
  * True if the VM name already exists, false otherwise
  */
  'exists': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "exists",
      "baseName": "exists",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CheckAzureVMNameExists200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

